import { useEffect, useState } from "react";

/**
 * Hook que devuelve el estado de conectividad del navegador.
 * Nota: navigator.onLine detecta solo si hay interfaz de red; no garantiza
 * alcance al backend. La cola offline confirma el éxito real del POST.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  return online;
}
